<script lang="ts">
	import { navigateToUrl } from 'src/components/Lists/list-helpers';
	import { format } from 'svelte-i18n';

	export let navigationLink;
</script>

<button class="button" on:click={() => navigateToUrl(navigationLink)}>
	<svg class="button-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
		<path
			d="M341.5 45.1C337.4 37.1 329.1 32 320.1 32C311.1 32 302.8 37.1 298.7 45.1L225.1 189.3L65.2 214.7C56.3 216.1 48.9 222.4 46.1 231C43.3 239.6 45.6 249 51.9 255.4L166.3 369.9L141.1 529.8C139.7 538.7 143.4 547.7 150.7 553C158 558.3 167.6 559.1 175.7 555L320.1 481.6L464.4 555C472.4 559.1 482.1 558.3 489.4 553C496.7 547.7 500.4 538.8 499 529.8L473.7 369.9L588.1 255.4C594.5 249 596.7 239.6 593.9 231C591.1 222.4 583.8 216.1 574.8 214.7L415 189.3L341.5 45.1z"
		/>
	</svg>
	{$format('button_black_friday_phase_1', { default: 'Join the VIP list' })}
</button>

<style>
	.button {
		padding: 16px 32px;
		font-size: 16px;
		font-weight: 500;
		color: #000000;
		background-color: #ececec;
		border: none;
		border-radius: 200px;
		-webkit-user-select: none;
		-moz-user-select: none;
		user-select: none;
		transition: transform 0.15s cubic-bezier(0.4, 0, 0.2, 1);
		-webkit-tap-highlight-color: transparent;
		cursor: pointer;
		background-image: none;
		text-align: center;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		gap: 8px;
		width: 100%;
		max-width: 350px;
		box-sizing: border-box;
	}
	.button:active {
		transform: scale(0.97);
	}
	.button-icon {
		width: 16px;
		height: 16px;
		fill: #dbb751;
		transition: transform 0.15s cubic-bezier(0.4, 0, 0.2, 1);
	}
	.button:hover .button-icon {
		animation: blink 0.8s ease-in-out 1;
	}
	@keyframes blink {
		0%,
		100% {
			opacity: 1;
			transform: scale(1);
		}
		50% {
			opacity: 0.7;
			transform: scale(1.2);
		}
	}
</style>
